// Port of api/fuel/app/classes/insights/ratings/weight.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'weight',
	detail: false,
	insight: false,
	run: function(type, owner, userIndex) {

		if (!owner.get_count_ratings()) return {}

		var weights = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		var rating = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

		var ratingIndex = Util.query(
			'SELECT g.game_weight_avg AS w, r.rating_value AS r' +
			' FROM rating r, game g' +
			' WHERE r.user_id IN (' + Util.in(userIndex) + ')' +
			' AND r.game_id = g.game_id'
		)

		for (var i = 0; i < ratingIndex.length; i++) {
			var item = ratingIndex[i]
			var w = parseFloat(item.w)
			var index = null

			if (w <= 1.24) index = 0
			else if (w <= 1.49) index = 1
			else if (w <= 1.74) index = 2
			else if (w <= 1.99) index = 3
			else if (w <= 2.24) index = 4
			else if (w <= 2.49) index = 5
			else if (w <= 2.74) index = 6
			else if (w <= 2.99) index = 7
			else if (w <= 3.24) index = 8
			else if (w <= 3.49) index = 9
			else if (w <= 3.74) index = 10
			else if (w <= 3.99) index = 11
			else if (w <= 4.24) index = 12
			else if (w <= 4.49) index = 13
			else if (w <= 4.74) index = 14
			else if (w <= 5) index = 15

			if (index !== null) {
				rating[index] += parseFloat(item.r)
				weights[index]++
			}
		}

		var bands = []

		for (var bi = 0; bi <= 15; bi++) {
			bands.push(weights[bi] ? Math.round((rating[bi] / weights[bi]) * 100) / 100 : 0)
		}

		return {
			weights: {
				counts: weights,
				bands: bands
			}
		}

	}
})
